import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../root/auth/auth.service';

@Component({
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.css'],
  standalone: false,
})
export class AuthCallbackComponent implements OnInit {
  constructor(private authService: AuthService) {}

  async ngOnInit(): Promise<void> {
    await this.authService.init();
  }
}
